export default function ColorDot({ hex }) {
	return <span style={{ marginBottom: '-1.5px', borderRadius: '50%', width: '.9em', height: '.9em', display: 'inline-block', background: hex, boxShadow: '0 0 2px inset rgba(0, 0, 0, 0.4)' }} />;
}